import {isObject} from './object';

export const mergeDeep = (target: any, ...sources: any[]): any => {
  if (!sources.length) {
    return target;
  }
  const source = sources.shift();

  if (target === undefined) {
    target = {};
  }

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, {[key]: {}});
        }
        mergeDeep(target[key], source[key]);
      } else if (source[key] !== '') {
        Object.assign(target, {[key]: source[key]});
      }
    }
  }
  return mergeDeep(target, ...sources);
};

export const getDeepValue = (obj: any, path: string): any => {
  if (!obj || !path) {
    return null;
  }

  let result = obj;
  path.split('.').forEach((fieldName) => {
    if (result !== undefined) {
      result = result[fieldName];
    }
  });
  return result;
};

export const setDeepValue = (obj: any, path: string, value: any): void => {
  if (!obj || !path) {
    return;
  }

  let node = obj;
  path.split('.').forEach((fieldName, index, array) => {
    const isLastItem = index === array.length - 1;
    if (node[fieldName] === undefined || isLastItem) {
      node[fieldName] = isLastItem ? value : {};
    }
    node = node[fieldName];
  });
};

// copied from this repo https://github.com/epoberezkin/fast-deep-equal

export function deepEqual(a: any, b: any): boolean {
  if (a === b) return true;

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (a.constructor !== b.constructor) return false;

    let length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) if (!deepEqual(a[i], b[i])) return false;
      return true;
    }

    if (a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      //@ts-ignore
      for (i of a.entries()) if (!b.has(i[0])) return false;
      //@ts-ignore
      for (i of a.entries()) if (!deepEqual(i[1], b.get(i[0]))) return false;
      return true;
    }

    if (a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      //@ts-ignore
      for (i of a.entries()) if (!b.has(i[0])) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0; ) {
      let key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }
      if (!deepEqual(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  // eslint-disable-next-line no-self-compare
  return a !== a && b !== b;
}
